import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType, SQDCEventActionTypePreset } from "@/graphql";

const router: Router.LicensedRouterExportType = [
  {
    path: "/audit",
    name: "AuditOverview",
    component: () => import("./views/AuditList.vue"),
    meta: {
      rights: ["audit.admin"],
    },
  },
  {
    path: "/AuditResultList/:id",
    name: "AuditResultList",
    redirect: (to) => {
      return {
        name: "AuditResultListWithFilter",
        params: {
          id: to.params.id,
          filter: "active",
        },
      };
    },
  },
  {
    path: "/AuditResultList/:id/:filter",
    name: "AuditResultListWithFilter",
    component: () => import("./views/AuditResultList.vue"),
  },
  {
    path: "/CreateAudit",
    name: "CreateAudit",
    component: () => import("./views/CreateAudit.vue"),
    meta: {
      rights: ["audit.admin"],
    },
  },
  {
    path: "/UpdateAudit/:id/:revision",
    name: "UpdateAudit",
    component: () => import("./views/UpdateAudit.vue"),
    meta: {
      rights: ["audit.admin"],
    },
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
      revision: route.params?.revision ? Number(route.params.revision) : undefined,
    }),
  },
  {
    path: "/auditResult/:id/:revision",
    name: "AuditResult",
    component: () => import("./views/AuditResult.vue"),
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
      revision: route.params.revision,
    }),
  },
  {
    path: "/appstore",
    name: "AppStore",
    component: () => import("./views/AppStore.vue"),
  },
  {
    path: "/audit/configOverview",
    name: "AuditResultConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["audit.admin"],
    },
    props: {
      internalType: SQDCEventActionTypeInternalType.Audit,
      presets: [SQDCEventActionTypePreset.Audit],
      titleKey: "router.AuditResultConfigOverview",
    },
  },
];

export default router;
